import { httpClient, ApiResponse, convertModelToFormData } from '@/utils';
import {
  FaqImportExportEndpoints,
  IFaqExportDTO,
  IFaqImportResponse,
  IImportFaqsDTO,
} from '@/models/faqImportExport.model';

class FaqImportExportAPI {
  static importFaqs({ file, ...params }: IImportFaqsDTO): ApiResponse<IFaqImportResponse> {
    const formData = convertModelToFormData({ file }, new FormData(), '', true);
    return httpClient.post<IFaqImportResponse>(FaqImportExportEndpoints.IMPORT, formData, { params });
  }

  static exportFaqs(params: IFaqExportDTO): ApiResponse<Blob> {
    return httpClient.get<Blob>(FaqImportExportEndpoints.EXPORT, { params });
  }
}

export default FaqImportExportAPI;
